//@ts-check
import React from 'react';
import GridView from './GridView';
import { HotKeys } from 'react-hotkeys';
import createContextMenuOption from '../contextMenu/createContextMenuOption';
/**
 *
 * @typedef {object} Props
 * @property {import('data/types').DataGridViewState<any>} config Data configuration
 * @property {(e: any, page: number) => any} onChangePage Change page handler
 */

/**
 * @param {Props} props
 */

var AccessibleGridView = function AccessibleGridView(props) {
  var getMenuWithKeys = function getMenuWithKeys() {
    if (props.config && props.config.contextMenu) return props.config.contextMenu.filter(function (e) {
      return !!e.key;
    });
    return [];
  };

  var getContextMenuOfSelection = function getContextMenuOfSelection(keyCommand) {
    if (props.config && props.config.data && props.config.data.length) {
      var menuOption = props.config.contextMenu.find(function (e) {
        return e.keyCommand === keyCommand;
      });

      if (menuOption) {
        var items = props.config.data.filter(function (i) {
          return i[props.config.selectedKeyProp || '_selected'];
        });

        if (items.length) {
          var result = items.map(function (item) {
            menuOption = createContextMenuOption(menuOption, item, props.config);
            if (menuOption.hidden) return null;
            return {
              menuOption: menuOption,
              item: item
            };
          }).filter(function (i) {
            return !!i;
          });
          return result;
        }
      }
    }

    return [];
  };

  var keymap = {
    PREV_PAGE: 'ctrl+left',
    NEXT_PAGE: 'ctrl+right'
  };
  var handlers = {
    PREV_PAGE: function PREV_PAGE(e) {
      props.onChangePage(e, props.config.view.page - 1);
    },
    NEXT_PAGE: function NEXT_PAGE(e) {
      props.onChangePage(e, props.config.view.page + 1);
    }
  };
  var menuWithKeys = getMenuWithKeys();
  menuWithKeys.map(function (menu) {
    keymap[menu.keyCommand] = menu.key;

    handlers[menu.keyCommand] = function (e) {
      var computedMenu = getContextMenuOfSelection(menu.keyCommand);

      if (computedMenu.length) {
        var option = computedMenu[0].menuOption;
        var dataItem = computedMenu[0].item;
        if (option && option.onClick) option.onClick(e, dataItem, props.config);
      }
    };
  });
  return React.createElement(HotKeys, {
    keyMap: keymap,
    handlers: handlers,
    style: {
      outline: 'none'
    }
  }, React.createElement(GridView, props));
};

export default AccessibleGridView;